import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-home-about',
    templateUrl: './home-about.component.html',
    styleUrls: ['./home-about.component.scss']
  })
  export class HomeAboutComponent {

    constructor(
        private translation: TranslateService
    ) { }    

    getSection2Text() {
        return this.translation.get('home.about.section2.text', {websiteLink: '<a href="http://www.hecht-kontaktlinsen.de/" target="_blank">website</a>'});
    }
    
      getSection3Text() {
        return this.translation.get('home.about.section3.text', {email: '<a href="mailto:info@hecht-contactlinsen.de">info@hecht-contactlinsen.de</a>'});
    }
  }